module.exports = __webpack_public_path__ + "media/icons/envelope--white-fdad6fd7.svg";